// extracted by mini-css-extract-plugin
module.exports = {"container":"_4d935d0799--container--NVMgc","icon":"_4d935d0799--icon--Wm56T","name":"_4d935d0799--name--VI4U6"};